import { Map } from "immutable";
import { createSelector } from "reselect";

export const makeGetCursorPaginationSelector = (type, id) =>
  createSelector(
    (state) => state.cursor_pagination[type],
    (collection) => {
      const value = collection?.get(`${id}`);
      return Map.isMap(value) ? value.toJS() : value;
    }
  );
